import Ajax from '../js/common/ajax';

export default {
    // 员工信息
    employee: {
        list(params = {}) { return Ajax.get('/salary-employee', params); },
        load(id) { return Ajax.get(`/salary-employee/${id}`); },
        delete(id) { return Ajax.delete(`/salary-employee/${id}`); },
        save(params = {}) { return Ajax.post('/salary-employee', params); },
        update(params = {}) { return Ajax.put('/salary-employee', params); },
        options() { return Ajax.get('/salary-employee/options'); },
        template() { return Ajax.get('/salary-employee/template', { responseType: 'blob' }); },
        importData(formData) { return Ajax.post('/salary-employee/import', formData); }
    },
    // 五险一金设置
    insurance: {
        list() { return Ajax.get('/salary-insurance'); },
        load(id) { return Ajax.get(`/salary-insurance/${id}`); },
        delete(id) { return Ajax.delete(`/salary-insurance/${id}`); },
        save(params = {}) { return Ajax.post('/salary-insurance', params); },
        update(params = {}) { return Ajax.put('/salary-insurance', params); }
    },
    // 工资信息(工资表)
    salary: {
        list(params = {}) { return Ajax.get('/salary', params); },
        load(id) { return Ajax.get(`/salary/${id}`); },
        delete(id) { return Ajax.delete(`/salary/${id}`); },
        save(params = {}) { return Ajax.post('/salary', params); },
        update(params = {}) { return Ajax.put('/salary', params); },
        generate(params = {}) { return Ajax.post('/salary/generate', params); },
        customItems() { return Ajax.get('/salary/custom-item'); },
        employees() { return Ajax.get('/salary/employees'); }
    },
    // 自定义工资项
    customItem: {
        list() { return Ajax.get('/salary-custom-item'); },
        load(id) { return Ajax.get(`/salary-custom-item/${id}`); },
        delete(id) { return Ajax.delete(`/salary-custom-item/${id}`); },
        save(params = {}) { return Ajax.post('/salary-custom-item', params); },
        update(params = {}) { return Ajax.put('/salary-custom-item', params); },
        options() { return Ajax.get('/salary-custom-item/options'); }
    },
    // 个税申报
    tax: {
        list(params = {}) { return Ajax.get('/salary-tax', params); },
        load(id) { return Ajax.get(`/salary-tax/${id}`); },
        delete(id) { return Ajax.delete(`/salary-tax/${id}`); },
        save(params = {}) { return Ajax.post('/salary-tax', params); },
        update(params = {}) { return Ajax.put('/salary-tax', params); },
        compute(params = {}) { return Ajax.post('/salary-tax/compute', params); },
        taxAccount(params = {}) { return Ajax.post('/salary-tax/tax-account', params); }
    }
};
